module.exports = __webpack_public_path__ + "static/media/featureImg3.5327a45b.png";